import React from "react";
import { Route, Switch } from "react-router-dom";
import {
  Navbar,
  SideMenu,
  DateDataTable,
  ComplaintOverview,
  ProgrammeOverview,
  FaultOverview,
  InspectOverview,
  MaintenanceOverview,
  CaseDetailsPage,
  PdfDownloadPage,
  ProgrammeDateDataTable,
  InspectionPage
} from "../../../components";
import { TYPE } from "../../../types";
import { Inventory } from "../inventory";

export const Dashboard: React.FC = (props) => {
  return (
    <div className="portal-layout">
      <Navbar />
      <div className="portal-layout-bottom">
        <SideMenu />
        <main>
          <div className="content-wrapper">
            <div className="content">
              <Switch>
                {/* Inventory Routes */}
                {([
                  "lamppost",
                  "lantern",
                  "bollard",
                  "controller",
                  "cable",
                  "gsds",
                  "connector",
                  "drawpit",
                ] as TYPE[]).map((key) => (
                  <Route
                    exact
                    key={key}
                    path={`/dashboard/inventory/${key}`}
                    component={() => <Inventory type={key} />}
                  />
                ))}

                {/* Complaint Routes */}
                {["complaint", "relationship"].map((key) => (
                  <Route
                    exact
                    key={key}
                    path={`/dashboard/complaint/${key}`}
                    component={() => (
                      <DateDataTable
                        region="ntw"
                        title="complaint"
                        subtitle={key}
                        path={`complaint/${key}`}
                      />
                    )}
                  />
                ))}
                <Route
                  exact
                  path="/dashboard/complaint/case"
                  component={() => <CaseDetailsPage />}
                />

                {/* Maintenance Routes */}
                {
                  [
                    { name: 'lamppost', searchKey: 'LAMP_NO' },
                    { name: 'bollard', searchKey: 'BOLLARD_NO' },
                    { name: 'controller', searchKey: 'CONTR_NO' },
                    { name: 'cable', searchKey: 'CABLE_NO' },
                    { name: 'gsds', searchKey: 'IT_AIDS_NO' },
                  ].map(({ name, searchKey }) => (
                    <Route
                      exact
                      key={name}
                      path={`/dashboard/maintenance/${name}`}
                      component={() => (
                        <DateDataTable
                          region="ntw"
                          title="maintenance"
                          subtitle={name}
                          path={`maintenance/${name}`}
                          monthSelector={false}
                          search={true}
                          searchKey={searchKey}
                        />
                      )}
                    />
                  ))
                }

                {/* Fault Routes */}
                {["lamppost", "bollard", "controller", "cable", "gsds"].map(
                  (key) => (
                    <Route
                      exact
                      key={key}
                      path={`/dashboard/fault/${key}`}
                      component={() => (
                        <DateDataTable
                          region="ntw"
                          title="fault"
                          subtitle={key}
                          path={`fault/${key}`}
                        />
                      )}
                    />
                  )
                )}

                {/* Programme Routes */}
                <Route
                  exact
                  path={"/dashboard/programme/programme"}
                  component={() => (
                    <ProgrammeDateDataTable
                      region="ntw"
                      title="programme"
                      subtitle="programme"
                      tablePath="programme/programme"
                      calendarPath="programme/calendar"
                    />
                  )}
                />

                <Route
                  exact
                  key="Inspection"
                  path="/dashboard/inspect/Inspection"
                  component={() => (
                    <InspectionPage
                      region="ntw"
                      title="inspect"
                      subtitle="Inspection"
                      path="inspect/Inspection"
                    />
                  )}
                />

                {/* Inspect Routes */}
                {["lantern", "column"].map((key) => (
                  <Route
                    exact
                    key={key}
                    path={`/dashboard/inspect/${key}`}
                    component={() => (
                      <DateDataTable
                        region="ntw"
                        title="inspect"
                        subtitle={key}
                        path={`inspect/${key}`}
                      />
                    )}
                  />
                ))}

                {/* Overview Routes */}
                <Route
                  exact
                  path="/dashboard/complaint/overview"
                  component={() => <ComplaintOverview />}
                />
                <Route
                  exact
                  path="/dashboard/programme/overview"
                  component={() => <ProgrammeOverview />}
                />
                <Route
                  exact
                  path="/dashboard/fault/overview"
                  component={() => <FaultOverview />}
                />
                <Route
                  exact
                  path="/dashboard/inspect/overview"
                  component={() => <InspectOverview />}
                />
                <Route
                  exact
                  path="/dashboard/maintenance/overview"
                  component={() => <MaintenanceOverview />}
                />
                <Route
                  exact
                  path="/dashboard/pdf/list"
                  component={() => (
                    <PdfDownloadPage
                      title="Monthly Report Download"
                      path={`pdf/list`}
                      downloadPath={`pdf/download/`}
                    />
                  )}
                />
              </Switch>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};
